export function OutlinePostventaIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_29848_88195)">
        <path
          d="M11.2266 23.2499C12.0532 23.2499 12.7232 22.5552 12.7232 21.6982C12.7232 20.8412 12.0532 20.1465 11.2266 20.1465C10.4 20.1465 9.72998 20.8412 9.72998 21.6982C9.72998 22.5552 10.4 23.2499 11.2266 23.2499Z"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />
        <path
          d="M19.458 23.2499C20.2846 23.2499 20.9547 22.5552 20.9547 21.6982C20.9547 20.8412 20.2846 20.1465 19.458 20.1465C18.6315 20.1465 17.9614 20.8412 17.9614 21.6982C17.9614 22.5552 18.6315 23.2499 19.458 23.2499Z"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />
        <path
          d="M0.75 3.85352H2.94714C3.55638 3.85352 4.08136 4.29031 4.21098 4.90854L6.99792 17.9182C7.12754 18.5365 7.659 18.9733 8.26176 18.9733H15.0314H21.8011"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.51221 13.2858C6.51221 13.2858 20.0969 13.2858 20.7256 13.2858C21.3542 13.2858 21.8857 12.8154 21.9894 12.177L23.182 3.98242"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1455 8.03536V0.75"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.4565 4.39268L14.1455 0.75L17.6869 4.39268"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_29848_88195">
          <rect width={width} height={height} fill={fill} />
        </clipPath>
      </defs>
    </svg>
  );
}
